<script>
    import app from './stores/app';
    import success from './stores/success';
    import {convertDate, generateApiKey} from './lib/lib';
    import {clientLoad, clientSave} from "./requests";

    let client = null;
    let history = null;
    let providers = [];
    let invoiceCollapsed = true;
    let error = null;

    const open = async () => {
        const [err, res] = await clientLoad($app.selectedClientId);

        providers = res.providers;
        if (!$app.selectedClientId || $app.selectedClientId === 0) {
            client = {
                id: 0,
                name: "",
                api_key: generateApiKey(),
                active: 1,
                provider: "",
                invoice: 0,
            };
        } else {
            client = res.client;
            client.invoice = 0;
            history = res.history;
        }

        error = null;
    }

    const Close = () => {
        app.editClient(null);
        app.clientChange(false);
    }

    const save = async () => {
        error = null;

        const [err, res] = await clientSave(client);

        if (err) {
            error = err;
            return;
        }

        if (client.id == 0) {
            success.show("Δημιουργήθηκε νέος πελάτης.");
        } else {
            success.show("Ο πελάτης ενημερώθηκε.");
        }

        app.editClient(null);
        app.clientChange(true);
    }

    const initialize = clientId => {
        if (clientId === undefined || clientId === null) {
            client = null;
        }
        if (clientId !== undefined && clientId !== null && clientId != 0) {
            client = null;
            open();
        }
        if (clientId === 0) {
            open();
        }
    }

    const creditsPriceChange = () => {
        if (client.credit_price && client.credits_add) {
            let price = (client.credit_price * client.credits_add).toFixed(2);
            let vat = 0;
            if (client.invoice == 1) {
                vat = price * 0.24;
                client.credits_vat = vat;
            } else {
                vat = 0;
                client.credits_vat = "";
            }
            client.credits_total_price = parseFloat(price) + parseFloat(vat);
        } else {
            client.credits_total_price = "";
            client.credits_vat = "";
        }
    }

    const toggleInvoicePanel = () => {
        invoiceCollapsed = !invoiceCollapsed;
    }

    const createApiKey = () => {
        if (client.api_key) {
            if (!window.confirm("Υπάρχει ήδη ένα κλειδί API για αυτό το λογαριασμό. Θέλετε να το αλλάξετε;")) {
                return false;
            }
        }
        client.api_key = generateApiKey();
    }

    $: {
        initialize($app.editClientId);
    }

</script>

{#if client !== null}
    <div class="popup-overlay visible">
        <div class="modal modal-lg">
            <div class="modal-header">
                <div class="modal-title">
                    { client.id > 0 ? client.name : 'Νέος Πελάτης' }
                </div>
                <div class="controls-right">
                    <span on:click="{ Close }"><i class="fa fa-times"></i></span>
                </div>
            </div>
            <div class="modal-body">
                <form on:submit|preventDefault="{ save }">
                    <div class="row">
                        <div class="col-md-7">
                            <div class="form-group">
                                <label>Επίθετο</label>
                                <div class="form-group">
                                    <input type="text" bind:value="{ client.lastname }" class="form-control">
                                </div>
                            </div>
                            <div class="form-group">
                                <label>Όνομα</label>
                                <div class="form-group">
                                    <input type="text" bind:value="{ client.name }" class="form-control">
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>Τηλέφωνο</label>
                                        <div class="form-group">
                                            <input type="phone" bind:value="{ client.phone }" class="form-control">
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>Κινητό</label>
                                        <div class="form-group">
                                            <input type="phone" bind:value="{ client.mobile }" class="form-control">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <label>Email</label>
                                <div class="form-group">
                                    <input type="email" bind:value="{ client.email }" class="form-control" required>
                                </div>
                            </div>
                            <hr>
                            <div class="form-group">
                                <label>Όνομα χρήστη</label>
                                <div class="form-group">
                                    <input type="text" bind:value="{ client.username }" class="form-control" required>
                                </div>
                            </div>
                            {#if client.id == 0}
                                <div class="form-group">
                                    <label>Κωδικός</label>
                                    <div class="form-group">
                                        <input type="text" bind:value="{ client.password }" class="form-control"
                                               required>
                                    </div>
                                </div>
                            {:else}
                                <div class="form-group">
                                    <label>Νέος Κωδικός</label>
                                    <div class="form-group">
                                        <input type="text" bind:value="{ client.new_password }" class="form-control">
                                    </div>
                                </div>
                            {/if}
                            <div class="form-group">
                                <label>Κλειδί API</label>
                                <div class="input-group">
                                    <input type="text" class="form-control" bind:value="{ client.api_key }">
                                    <span class="input-group-addon" style="cursor:pointer;" title="Δημιουργία κλειδιού"
                                          on:click={ createApiKey }><i class="fa fa-key"></i></span>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>Ενεργός</label>
                                        <div class="form-group">
                                            <select bind:value="{ client.active }" class="form-control">
                                                <option value="1" selected="{ client.active == 1}">Ναι</option>
                                                <option value="0">Όχι</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- invoice data -->
                            <div class="panel ec-panel mrg-b-none">
                                <div class="panel-heading" on:click="{ toggleInvoicePanel }">
                                    ΣΤΟΙΧΕΙΑ ΠΑΡΑΣΤΑΤΙΚΟΥ
                                    <div class="toggler">
                                        <i class="fa" class:fa-chevron-left="{ !invoiceCollapsed }"
                                           class:fa-chevron-down="{ invoiceCollapsed }"></i>
                                    </div>
                                </div>
                                <div class="panel-body" class:collapsed="{ invoiceCollapsed }">
                                    <div class="form-group">
                                        <label>ΕΠΩΝΥΜΙΑ</label>
                                        <input type="text" bind:value="{ client.company }" class="form-control">
                                    </div>
                                    <div class="form-group">
                                        <label>ΕΠΑΓΓΕΛΜΑ</label>
                                        <input type="text" bind:value="{ client.occupation }" class="form-control">
                                    </div>
                                    <div class="form-group">
                                        <label>Α.Φ.Μ.</label>
                                        <input type="text" bind:value="{ client.afm }" class="form-control">
                                    </div>
                                    <div class="form-group">
                                        <label>Δ.Ο.Υ.</label>
                                        <input type="text" bind:value="{ client.doy }" class="form-control">
                                    </div>
                                    <div class="form-group">
                                        <label>Διεύθυνση</label>
                                        <input type="text" bind:value="{ client.address }" class="form-control">
                                    </div>
                                    <div class="form-group">
                                        <label>Τ.Κ.</label>
                                        <input type="text" bind:value="{ client.post_code }" class="form-control">
                                    </div>
                                    <div class="form-group">
                                        <label>Πόλη</label>
                                        <input type="text" bind:value="{ client.city }" class="form-control">
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div class="col-md-5">
                            <div class="form-group">
                                <label>Αποστολέας</label>
                                <div class="form-group">
                                    <input type="text" bind:value="{ client.originator }" class="form-control" required>
                                </div>
                            </div>
                            <div class="form-group">
                                <label>Μονάδες</label>
                                <div class="form-group">
                                    <input type="text" bind:value="{ client.credits }" class="form-control" disabled>
                                </div>
                            </div>
                            <div class="form-group">
                                <label>Προσθήκη μονάδων</label>
                                <div class="form-group">
                                    <input type="number" bind:value="{ client.credits_add }" class="form-control"
                                           on:keyup="{ creditsPriceChange }">
                                </div>
                            </div>
                            <div class="form-group">
                                <label>Τιμή μονάδας</label>
                                <div class="form-group">
                                    <input type="text" bind:value="{ client.credit_price }" class="form-control"
                                           on:keyup="{ creditsPriceChange }">
                                </div>
                            </div>
                            <div class="form-group">
                                <label>ΦΠΑ(%)</label>
                                <div class="form-group">
                                    <input type="number" bind:value="{ client.credits_vat }" class="form-control"
                                           on:keyup="{ creditsPriceChange }" disabled>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="checkbox">
                                    <label>
                                        <input type="checkbox"
                                               bind:checked="{ client.invoice }" on:change="{ creditsPriceChange }">
                                        Έκδοση τιμολογίου
                                    </label>
                                </div>
                            </div>
                            <div class="form-group">
                                <label>Σύνολο</label>
                                <div class="form-group">
                                    <input type="text" bind:value="{ client.credits_total_price }" class="form-control"
                                           disabled>
                                </div>
                            </div>
                            {#if history}
                                <p class="text-small">
                                    Τελευταία τιμή μονάδας: { history.credit_price } (στα { history.credits })<br>
                                    στις { convertDate(history.date_created) }
                                </p>
                            {/if}

                            <div class="form-group">
                                <label>Provider</label>
                                <select bind:value="{ client.provider }" class="form-control">
                                    <option value="">[προεπιλογή]</option>
                                    {#each providers as prov}
                                        <option value="{ prov.id }"
                                                selected="{ client.provider === prov.id}">{ prov.name }</option>
                                    {/each}
                                </select>
                            </div>
                        </div>
                    </div>
                    <hr>

                    {#if (error)}
                        <div class="alert alert-danger">{error}</div>
                    {/if}
                    <div class="text-right">
                        <input type="submit" class="btn btn-primary" value="OK">
                        <a href="#" class="btn btn-default" on:click|preventDefault="{ Close }">Ακύρωση</a>
                    </div>

                </form>
            </div>
        </div>
    </div>
{/if}

